import { render, staticRenderFns } from "./FbCard.vue?vue&type=template&id=fdb61c28&scoped=true"
import script from "./FbCard.vue?vue&type=script&lang=js"
export * from "./FbCard.vue?vue&type=script&lang=js"
import style0 from "./FbCard.vue?vue&type=style&index=0&id=fdb61c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb61c28",
  null
  
)

export default component.exports